import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  standalone: false,
  selector: 'app-meta-bar',
  templateUrl: './meta-bar.component.html',
  styleUrls: ['./meta-bar.component.css']
})
export class MetaBarComponent implements OnInit {
  @Input() referenceId: string = '';

  isInstructionsEnabled = false;
  private instructionText = '';

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    this.isInstructionsEnabled = window.localStorage.getItem('fc_instruction_enabled') === 'true';
    this.instructionText = window.localStorage.getItem('fc_instruction_text') || '';
  }

  showInstructions(): void {
    if (!this.instructionText) {
      return;
    }
    const modalRef = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    modalRef.componentInstance.name = this.instructionText;
  }
}
